import type { CSSProperties } from 'react';

// ─── Keyframes (injected once) ───────────────────────────────────────────────

if (typeof document !== 'undefined' && !document.getElementById('deploy-keyframes')) {
  const style = document.createElement('style');
  style.id = 'deploy-keyframes';
  style.textContent = '@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }';
  document.head.appendChild(style);
}

// ─── Shared Styles ───────────────────────────────────────────────────────────

export const card: CSSProperties = {
  background: 'var(--color-bg-secondary)',
  border: '1px solid var(--color-border-opaque)',
  borderRadius: 12,
  padding: 20,
};

export const sectionTitle: CSSProperties = {
  fontSize: 'var(--font-size-title3)',
  lineHeight: 'var(--line-height-title3)',
  letterSpacing: 'var(--letter-spacing-title3)',
  fontWeight: 600,
  color: 'var(--color-label-primary)',
  marginBottom: 16,
};

export const labelSecondary: CSSProperties = {
  color: 'var(--color-label-secondary)',
  fontSize: 'var(--font-size-body)',
  lineHeight: 'var(--line-height-body)',
};

export const badge = (bg: string, fg: string): CSSProperties => ({
  display: 'inline-block',
  padding: '2px 8px',
  borderRadius: 'var(--radius-full)',
  fontSize: 'var(--font-size-caption)',
  lineHeight: 'var(--line-height-caption)',
  fontWeight: 600,
  background: bg,
  color: fg,
});

export const metricCard: CSSProperties = {
  ...card,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4,
  padding: '16px 12px',
};

export const metricValue: CSSProperties = {
  fontSize: 'var(--font-size-title2)',
  fontWeight: 700,
  color: 'var(--color-label-primary)',
};

export const metricLabel: CSSProperties = {
  fontSize: 'var(--font-size-caption)',
  color: 'var(--color-label-tertiary)',
  textAlign: 'center',
};

export const gitBtnBase: CSSProperties = {
  border: 'none',
  borderRadius: 'var(--radius-sm)',
  fontSize: 'var(--font-size-caption)',
  fontWeight: 600,
  cursor: 'pointer',
  padding: '4px 12px',
  minHeight: 28,
  whiteSpace: 'nowrap' as const,
  transition: 'opacity 0.15s',
};

export const gitBtnPrimary: CSSProperties = {
  ...gitBtnBase,
  background: 'var(--color-primary-default, var(--color-tint-blue))',
  color: 'var(--color-static-white)',
};

export const gitBtnGhost: CSSProperties = {
  ...gitBtnBase,
  background: 'var(--color-fill-secondary)',
  color: 'var(--color-label-primary)',
};

export const gitBtnDanger: CSSProperties = {
  ...gitBtnBase,
  background: 'var(--color-tint-red)',
  color: 'var(--color-static-white)',
};
